/* eslint-disable complexity */
import { ChartData } from './types';
import { Planwert } from '@/domain/controlling/entities/planwert';

export function getChartData({
  jahr,
  monat,
  type,
  planwerte,
}: {
  jahr: number;
  monat: number;
  type: 'absatz' | 'umsatz';
  planwerte: Planwert[];
}): ChartData[] {
  const chartData: ChartData[] = [];

  const datesOfCurrenctMonth = Array.from(
    {
      length: new Date(jahr, monat, 0).getDate(),
    },
    (_, i) => new Date(jahr, monat - 1, i + 2).toISOString().split('T')[0],
  );

  if (type === 'umsatz') {
    datesOfCurrenctMonth.forEach((datum) => {
      const currentPlanwert = planwerte.find(
        (umsatzPlan) => umsatzPlan.datum === datum,
      );

      const newChartDataEntry = {
        datum,
        planwert:
          currentPlanwert &&
          currentPlanwert.umsatzPlan.umsatz &&
          currentPlanwert.umsatzPlan.umsatz.wert
            ? currentPlanwert.umsatzPlan.umsatz.wert.amount
            : 0,
        prognose:
          currentPlanwert && currentPlanwert.umsatzPlan.prognose
            ? currentPlanwert.umsatzPlan.prognose.amount
            : 0,
        zielstunden:
          currentPlanwert &&
          currentPlanwert.umsatzPlan.umsatz &&
          currentPlanwert.umsatzPlan.umsatz.stunden
            ? currentPlanwert.umsatzPlan.umsatz.stunden
            : 0,
      };
      chartData.push(newChartDataEntry);
    });
  } else {
    datesOfCurrenctMonth.forEach((datum) => {
      const currentPlanwert = planwerte.find(
        (absatzPlan) => absatzPlan.datum === datum,
      );

      const newChartDataEntry = {
        datum,
        planwert:
          currentPlanwert &&
          currentPlanwert.absatzPlan.absatz &&
          currentPlanwert.absatzPlan.absatz.wert
            ? currentPlanwert.absatzPlan.absatz.wert
            : 0,
        prognose:
          currentPlanwert && currentPlanwert.absatzPlan.prognose
            ? currentPlanwert.absatzPlan.prognose
            : 0,
        zielstunden:
          currentPlanwert &&
          currentPlanwert.absatzPlan.absatz &&
          currentPlanwert.absatzPlan.absatz.stunden
            ? currentPlanwert.absatzPlan.absatz.stunden
            : 0,
      };
      chartData.push(newChartDataEntry);
    });
  }
  return chartData;
}
